module.exports = __webpack_public_path__ + "static/media/cerebro.859a41e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/components/Sidebar/images/cerebro.jpg
// module id = 488
// module chunks = 0